<!--
 * @Description: hw16v
 * @Date: 2024-01-18 11:09:50
 * @Author: caogt
-->
<template>
  <div class="template-container">
    <div class="container-main">
      <div class="main-top-box">
        <img class="img-top" src="/static/images/industry/hw16v/photo4.png" />
        <div class="img-text-box">
          <img
            class="img-text"
            src="/static/images/industry/hw150v/photo1.png"
          />
          电动垂直起降复合翼无人机
        </div>
      </div>
      <div>
        <div class="main-text1">行业产品 > 工业整机 > HW-16V</div>
        <div class="main-text2">HW-16V性能优势</div>
        <div class="main-text3">
          采用三余度安全飞控，双天线差分定向，机载AI算力，具有：长航时、全场景、模块化、垂直起降等众多优点，非常适用于远程实时视频巡检场景
        </div>
        <div class="img-details-box">
          <div class="img-details-content">
            <div class="img-details-left">
              <div class="left-text left-text1" :class="advNum==0?'left-text-hover':''" @mouseover="advNum=0">1</div>
              <div class="left-text left-text2" :class="advNum==1?'left-text-hover':''" @mouseover="advNum=1">2</div>
              <div class="left-text left-text3" :class="advNum==2?'left-text-hover':''" @mouseover="advNum=2">3</div>
              <div class="left-text left-text4" :class="advNum==3?'left-text-hover':''" @mouseover="advNum=3">4</div>
              <div class="left-text left-text5" :class="advNum==4?'left-text-hover':''" @mouseover="advNum=4">5</div>
              <div class="left-text left-text6" :class="advNum==5?'left-text-hover':''" @mouseover="advNum=5">6</div>
            </div>
            <div class="img-details-right">
              <div class="right-title">{{advantages[advNum].title}}</div>
              <div class="right-text-box">
                <img
                  class="img-check"
                  src="/static/images/industry/hw16v/check.png"
                />
                <div>纯电动立驱动，一次起飞更长有效作业时间</div>
              </div>
            </div>
          </div>
          <img
            class="img-details"
            src="/static/images/industry/hw16v/photo3.png"
          />
        </div>
      </div>
      <div class="main-bottom-box">
        <img
          class="img-bottom"
          src="/static/images/industry/hw16v/photo2.png"
        />
        <div class="img-text-box2">
          电动垂直起降复合翼无人机
          <div class="img-text2">
            警用、测绘、石油、电力、应急、环保、海事、林草
          </div>
        </div>
      </div>
      <div class="main-bottom-list">
        <div class="main-text2">产品参数</div>
        <div class="list-item" style="margin-top: 30px">
          <div class="list-name">翼展</div>
          3.38m
        </div>
        <div class="list-item">
          <div class="list-name">机长</div>
          1.52m
        </div>
        <div class="list-item">
          <div class="list-name">续航时间</div>
          180min
        </div>
        <div class="list-item">
          <div class="list-name">巡航速度</div>
          65~120km/h
        </div>
        <div class="list-item">
          <div class="list-name">最大起飞重量</div>
          16.5kg
        </div>
        <div class="list-item">
          <div class="list-name">起降模式</div>
          垂直起降
        </div>
        <div class="list-item">
          <div class="list-name">有效载荷</div>
          3kg
        </div>
        <div class="list-item">
          <div class="list-name">抗风能力</div>
          7级
        </div>
        <div class="list-item">
          <div class="list-name">运输箱尺寸</div>
          1350x600x450mm
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { isMobileDevice } from '@/common/scripts/isMobile.js';

export default {
  data() {
    return {
      advantages: [
        {
          title: "纯电动 长航时",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时2",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时3",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时4",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时5",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
        {
          title: "纯电动 长航时6",
          value: "纯电动立驱动，一次起飞更长有效作业时间",
        },
      ],
      advNum: 0,
    };
  },
  mounted() {},
  methods: {
   
  },
};
</script>

<style scoped lang="stylus">
.template-container {
  width: 100%;
  display: flex;

  .container-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-text1 {
      margin-top: 20px;
      font-size: 12px;
      font-weight: 500;
      line-height: 29px;
      color: #3D3D3D;
    }

    .main-text2 {
      margin-top: 64px;
      font-size: 36px;
      font-weight: 500;
      line-height: 29px;
      color: #1F416B;
    }

    .main-text3 {
      max-width: 1296px;
      margin-top: 48px;
      margin-bottom: 92px;
      font-size: 16px;
      font-weight: 500;
      line-height: 29px;
      color: #A6A6A6;
    }

    .main-top-box {
      background-color: #1F416B;
      width: 100%;
      max-width: 1920px;
      max-height: 800px;

      .img-top {
        position: relative;
        object-fit: cover;
        width: 100%;
        max-width: 1920px;
        height: 800px;
        opacity :0.8;
      }

      .img-text-box {
        align-items: flex-start;
        font-weight: 800;
        font-size: 24px;
        line-height: 29px;
        color: white;
        position: absolute;
        top: 325px;
        margin-left: 18.2%;
        display: flex;
        flex-direction: column;
        height: 177px;

        .img-text {
          height: 144px;
          object-fit: contrast;
        }
      }
    }

    .img-details-box {
      width: 1296px;
      height: 540px;

      .img-details {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .img-details-content {
        display: flex;
        position: absolute;
        width: 1296px;
        height: 540px;

        .img-details-left {
          font-size: 24px;
          line-height: 39px;
          font-weight: 500;
          width: 936px;
          height: 540px;

          .left-text {
            position: absolute;
            top: 256px;
            left: 525px;
            background: rgba(0, 0, 0, 0.4);
            box-sizing: border-box;
            border: 3px solid #FFFFFF;
            border-radius: 22px;
            width: 44px;
            height: 44px;
            color: #fff;
            text-align: center;
          }
          .left-text-hover{
            color: #007BE7;
            border: 3px solid  #007BE7;
          }

          .left-text1 {
            top: 256px;
            left: 525px;
          }

          .left-text2 {
            top: 264px;
            left: 315px;
          }

          .left-text3 {
            top: 354px;
            left: 507px;
          }

          .left-text4 {
            top: 354px;
            left: 593px;
          }

          .left-text5 {
            top: 242px;
            left: 752px;
          }

          .left-text6 {
            top: 198px;
            left: 671px;
          }
        }

        .img-details-right {
          width: 360px;
          height: 540px;
          background-color: rgba(255, 255, 255, 0.8);

          .right-title {
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
            color: #3D3D3D;
            margin-top: 57px;
            margin-left: 39px;
          }

          .right-text-box {
            line-height: 29px;
            font-size: 16px;
            font-weight: 500;
            margin: 30px 38px 0px 39px;
            display: flex;
            color: #666;

            .img-check {
              margin-top: 3px;
              margin-right: 11px;
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }

    .main-bottom-box {
      margin-top: 121px;
      width: 100%;
      max-width: 1920px;
      max-height: 520px;

      .img-bottom {
        position: relative;
        object-fit: cover;
        width: 100%;
        max-width: 1920px;
        height: 520px;
      }

      .img-text-box2 {
        text-align: center;
        color: white;
        position: absolute;
        margin-top: -300px;
        max-width: 1920px;
        width: 100%;
        font-size: 36px;
        font-weight: 500;

        .img-text2 {
          margin-top: 38px;
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    .main-bottom-list {
      margin-top: 63px;
      margin-bottom: 82px;

      .list-title {
      }

      .list-item {
        display: flex;
        height: 58px;
        width: 1280px;
        border-bottom: 1px solid #D8D8D8;
        font-size: 18px;
        color: #777;
        line-height: 57px;
      }

      .list-name {
        flex: 1;
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    width: 100%;

    .container-main {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry/hw25v.vue